import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import WorkshopInfo from '../../entities/tracing/workshopinfo'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface WorkshopInfoState extends ListState<WorkshopInfo>{
    editModel: WorkshopInfo;
    reportList: Array<any>;
}
class WorkshopInfoModule extends ListModule<WorkshopInfoState,any,WorkshopInfo>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<WorkshopInfo>(),
        loading:false,
        editModel: new WorkshopInfo(),
        activeList: new Array<WorkshopInfo>(),
        reportList: new Array<any>(),
        path: 'workshop-infos'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async importData(context: ActionContext<WorkshopInfoState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/workshop-infos/import',
                payload.data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.reportList = response.data.result;
            return true;
        },
        async updateBatch(context: ActionContext<WorkshopInfoState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/workshop-infos/batch', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
        async reportInfo(context: ActionContext<WorkshopInfoState, any>, payload: any) {
            context.state.loading = true;
            context.state.reportList = [];
            let reponse = await Ajax.get('/api/reports/report-info', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.reportList = reponse.data.result;
            context.state.loading = false;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: WorkshopInfoState, model: WorkshopInfo) {
            state.editModel = model;
            
        }, 
        new(state: WorkshopInfoState, model: WorkshopInfo) {
            state.editModel = Object.assign({});
            state.editModel.dealer_id = 1;
        }, 
        setReportList(state: WorkshopInfoState, list: Array<any>) {
            state.reportList = list;
        },
    });
}
const workshopinfoModule=new WorkshopInfoModule();
export default workshopinfoModule;
